import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
  makeStyles,
} from "@material-ui/core";
import SFDialogTitle from "./SFDialogTitle";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import TextField from "@material-ui/core/TextField";
import { useState, useContext } from "react";
import DialogCloseButton from "../components/DialogCloseButton";
import { PaymentCreateContext } from "../pages/payment/payment-addproduct/PaymentCreateContext";
import { useTranslate } from "react-admin";
import { savePaymentGuestState } from "../utils";
import Guest from "../models/Guest";

const useStyles = makeStyles((theme) => ({
  allContainer: {
    width: 695,
    margin: "0 auto",
    paddingTop: 50,
  },
  title: {
    fontSize: 30,
    color: theme.orange,
  },
  paper: {
    margin: 0,
    width: 695,
    height: 490,
    maxWidth: 695,
    maxHeight: 500,
    borderRadius: "10px",
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    margin: "0 auto",
    alignItems: "start",
    padding: 0,
  },
  topSection: {
    display: "flex",
    flexDirection: "column",
    margin: "0 auto",
    alignItems: "start",
    flexGrow: 1,
  },
  toggleButtonGroup: { marginTop: 16 },
  toggleGenderButton: {
    width: 159,
    height: 38,
    borderRadius: "26px !important",
    marginRight: 20,
    borderWidth: "2px !important",
    borderColor: "orange !important",
    color: theme.orange,
  },
  toggleButtonText: {
    color: theme.orange,
  },
  toggleAgeRangeButton: {
    width: 108,
    height: 38,
    borderRadius: "26px !important",
    marginRight: 20,
    borderWidth: "2px !important",
    borderColor: "orange !important",
    color: theme.orange,
  },
  selected: {
    backgroundColor: "orange!important",
    color: "white!important",
  },
  hashtagTextField: {
    marginTop: 2,
    width: 509,
    height: 37,
  },
  authorizeTextField: {
    width: 396,
    height: 66,
  },
  buttonContainer: {},
  button: {
    borderRadius: "0 0 0 0",
    margin: "0 !important",
    height: 69,
    fontSize: 20,
    marginLeft: 0,
    marginRight: 0,
  },
  dialogAction: {
    padding: 0,
    display: "grid",
    gridTemplateColumns: "50% 50%",
    height: 69,
  },
}));

const WalkinInfoDialog = () => {
  const classes = useStyles();
  const translate = useTranslate();
  const [state, dispatch] = useContext(PaymentCreateContext);
  const [gender, setGender] = useState("");
  const [age, setAge] = useState("");
  const [hashtags, setHashtags] = useState("");

  const handleGenderChange = (_, newValue) => {
    setGender(newValue);
  };

  const handleAgeRangeChange = (_, newValue) => {
    setAge(newValue);
  };

  return (
    <Dialog
      onClose={() => null}
      aria-labelledby="customized-dialog-title"
      open={state.showWalkinInfoDialog}
      classes={{ root: classes.allContainer, paper: classes.paper }}
    >
      <SFDialogTitle
        id="customized-dialog-title"
        onClose={null}
        title={translate("ra.text.walkinInfo.walkInInformation")}
        disableClose={true}
        style={{ padding: "20px 24px 2px" }}
      />{" "}
      <DialogCloseButton
        onClose={() => {
          dispatch({
            type: "SET_GUEST",
            payload: {},
          });
          dispatch({
            type: "HIDE_WALKIN",
          });
          return;
          //history.goBack();
        }}
      />
      <DialogContent classes={{ root: classes.dialogContent }}>
        <Box className={classes.topSection}>
          <Typography
            align="left"
            style={{ marginTop: 16, alignSelf: "start" }}
          >
            {translate("ra.text.gender")}
          </Typography>
          <ToggleButtonGroup
            classes={{ grouped: classes.toggleButtonGroup }}
            value={gender}
            exclusive
            onChange={handleGenderChange}
            aria-label="gender-type"
          >
            <ToggleButton
              value="Female"
              aria-label="female"
              classes={{ selected: classes.selected }}
              className={classes.toggleGenderButton}
            >
              {translate("ra.text.Female")}
            </ToggleButton>
            <ToggleButton
              value="Male"
              aria-label="amount"
              classes={{ selected: classes.selected }}
              className={classes.toggleGenderButton}
            >
              {translate("ra.text.Male")}
            </ToggleButton>
            <ToggleButton
              value="Other"
              aria-label="code"
              classes={{ selected: classes.selected }}
              className={classes.toggleGenderButton}
            >
              {translate("ra.text.other")}
            </ToggleButton>
          </ToggleButtonGroup>
          <Typography align="left" style={{ marginTop: 16 }}>
            {translate("ra.text.age")}
          </Typography>
          <ToggleButtonGroup
            classes={{ grouped: classes.toggleButtonGroup }}
            value={age}
            exclusive
            onChange={handleAgeRangeChange}
            aria-label="age"
          >
            <ToggleButton
              value="1-12"
              aria-label="1-12"
              classes={{ selected: classes.selected }}
              className={classes.toggleAgeRangeButton}
            >
              1-12
            </ToggleButton>
            <ToggleButton
              value="13-24"
              aria-label="amount"
              classes={{ selected: classes.selected }}
              className={classes.toggleAgeRangeButton}
            >
              13-24
            </ToggleButton>
            <ToggleButton
              value="25-60"
              aria-label="code"
              classes={{ selected: classes.selected }}
              className={classes.toggleAgeRangeButton}
            >
              25-60
            </ToggleButton>
            <ToggleButton
              value="Over 60"
              aria-label="code"
              classes={{ selected: classes.selected }}
              className={classes.toggleAgeRangeButton}
            >
              over 60
            </ToggleButton>
          </ToggleButtonGroup>
          <Typography align="left" style={{ marginTop: 31 }}>
            {translate("ra.text.walkinInfo.hashtagExample")}
          </Typography>

          <TextField
            variant="outlined"
            classes={{ root: classes.hashtagTextField }}
            value={hashtags}
            onChange={(e) => setHashtags(e.target.value)}
            align="right"
            placeholder={""}
          />
        </Box>
      </DialogContent>
      <DialogActions className={classes.dialogAction}>
        <Button
          onClick={() => {
            savePaymentGuestState(new Guest({}));
            dispatch({
              type: "SET_GUEST",
              payload: {},
            });
            dispatch({
              type: "HIDE_WALKIN",
            });
            savePaymentGuestState(state.guest);
            return;
            //history.goBack();
          }}
          color="secondary"
          fullWidth
          variant="contained"
          className={classes.button}
          disabled={false}
        >
          {translate("ra.text.skip")}
        </Button>
        <Button
          onClick={() => {
            savePaymentGuestState(
              new Guest({
                gender,
                age,
                hashtags: hashtags.split(",").reduce((total, tag) => {
                  if (tag.trim() !== "") {
                    total.push("#" + tag.replace("#", "").trim());
                  }
                  return total;
                }, []),
              })
            );
            dispatch({
              type: "SET_GUEST",
              payload: {
                gender,
                age,
                hashtags: hashtags.split(",").reduce((total, tag) => {
                  if (tag.trim() !== "") {
                    total.push("#" + tag.replace("#", "").trim());
                  }
                  return total;
                }, []),
              },
            });
            return dispatch({
              type: "HIDE_WALKIN",
            });
          }}
          color="primary"
          variant="contained"
          className={classes.button}
          disabled={age === "" || gender === ""}
        >
          {translate("ra.text.done")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WalkinInfoDialog;
